import { ResponseTime } from "@/types/types";

export function getResponseTimeUI(response: number): {
  status: "fast" | "normal" | "slow";
  displayType: "minutes" | "hour" | "hours";
  value: number;
} {
  const minutes = response;

  let status: "fast" | "normal" | "slow";

  if (minutes <= 60) {
    status = "fast";
  } else if (minutes <= 180) {
    status = "normal";
  } else {
    status = "slow";
  }

  if (minutes < 60) {
    return {
      status,
      displayType: "minutes",
      value: minutes,
    };
  }

  if (minutes < 90) {
    return {
      status,
      displayType: "hour",
      value: Math.round(minutes / 60),
    };
  }

  return {
    status,
    displayType: "hours",
    value: Math.round(minutes / 60),
  };
}
